/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1RecruitmentModel } from '../../entities/v1/RecruitmentModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { domainRecruiterNewDriverDriverSegmentSchema } from '../domain/recruiterNewDriverDriverSegmentSchema'
import { domainRecruiterNewDriverInfoSchema } from '../domain/recruiterNewDriverInfoSchema'
import { domainRecruiterNewDriverStatusSchema } from '../domain/recruiterNewDriverStatusSchema'
import { v1UserRequestModelSchema } from './userRequestModelSchema'
import { z } from 'zod'

export const v1RecruitmentModelSchema = z.object({
  created_at: z.string(),
  deleted_at: z.string().optional(),
  driver_segment: z.lazy(() => domainRecruiterNewDriverDriverSegmentSchema),
  end_at: z.string(),
  id: z.string(),
  info: z.lazy(() => domainRecruiterNewDriverInfoSchema),
  phone: z.number().int(),
  status: z.lazy(() => domainRecruiterNewDriverStatusSchema),
  user_request: z.lazy(() => v1UserRequestModelSchema).optional(),
}) as unknown as ToZod<V1RecruitmentModel>